var React = require('react');

function SnowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon_snow","d":"M14.379,23.77,8.836,29.254l5.543-5.484V16l-6.8,3.886L5.551,27.377l2.023-7.489L.377,24l7.2-4.112v0L0,17.875l7.574,2.008v0L14.379,16v0l-6.8-3.886L0,14.121l7.574-2.008L.377,8l7.2,4.113h0L5.551,4.619l2.023,7.494h0L14.379,16V8.227L8.836,2.742l5.543,5.484V16h0l6.807-3.887h0L28.389,8l-7.2,4.113,7.572,2.008-7.572-2.008L14.383,16l6.8,3.885v0L28.389,24l-7.2-4.115,2.031,7.492-2.031-7.492L14.383,16l0,0Zm0-7.768,0,0h0Zm0,7.768,5.547,5.484Zm14.383-5.895-7.576,2.008ZM23.217,4.619l-2.031,7.494ZM19.926,2.742,14.379,8.227Z","transform":"translate(0.5 0.5)","fill":"none","stroke":"#20415b","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"}));
}

SnowIcon.defaultProps = {"width":"29.762","height":"33","viewBox":"0 0 29.762 33"};

module.exports = SnowIcon;

SnowIcon.default = SnowIcon;
